module.exports = __webpack_public_path__ + "static/media/iconSearch.5c4d178b.svg";